<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from "vue"
import { usePackaging } from "@/composables/usePackaging"
import NBPopover from "@/app/Checkout/components/common/NBPopover/index.vue"
import Packaging from "@/app/Checkout/components/common/Packaging/index.vue"
import CartItems from "@/app/Checkout/components/desktop/CartItems/index.vue"
import PaymentMethods from "@/app/Checkout/components/desktop/PaymentMethods/index.vue"
import CheckoutAddress from "@/app/Checkout/components/desktop/CheckoutAddress/index.vue"
import ShippingMethods from "@/app/Checkout/components/desktop/ShippingMethods/index.vue"

const checkoutAddress = ref(null)
const { showWrappingSelection } = usePackaging()
const image = '/images/accessories/geschenkverpackung.png'

function shippingFormData() {
  return checkoutAddress.value?.shippingFormData()
}

function invoiceFormData() {
  return checkoutAddress.value?.invoiceFormData()
}

function validateShippingAddressForm() {
  return checkoutAddress.value ? checkoutAddress.value.validateShippingAddressForm() : false
}
function validateInvoiceAddressForm() {
  return checkoutAddress.value ? checkoutAddress.value.validateInvoiceAddressForm() : false
}

defineExpose({
  invoiceFormData,
  shippingFormData,
  validateInvoiceAddressForm,
  validateShippingAddressForm,
})
</script>
